import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Toolbar from 'components/Layout/Toolbar';
import {
  ICriticalityMetrics,
  IHistoryMetrics,
  IScoreMetrics,
  IVentureStatusMetrics,
  statusesDashboard,
} from 'interfaces/dashboard';
import React, { useState } from 'react';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import RxOp from 'rxjs-operators';
import dashboardService from 'services/dashboard';
import entityService from 'services/entity';
import selectedVentureService from 'services/profile';
import ventureService from 'services/venture';

import CardGraphs from '../Component/Card';
import DocsActives from '../Graphs/Actives';
import DocumentCriticality from '../Graphs/Criticality';
import HistoricStatus from '../Graphs/HistoricStatus';
import ScoreVenture from '../Graphs/Score';
import DocumentStatus from '../Graphs/Status';

const useStyles = makeStyles({
  title: {
    fontWeight: 700,
  }
});

const ViewVenture = () => {
  const params = useParams<{ ventureId: number; entityId: number }>();
  const [ventureMetrics, setVentureMetrics] = useState<IVentureStatusMetrics>();
  const [critacalityMetrics, setCritacalityMetrics] = useState<ICriticalityMetrics[]>();
  const [scoreMetrics, setScoreMetrics] = useState<IScoreMetrics>();
  const [historyMetrics, setHistoryMetrics] = useState<IHistoryMetrics>();

  const [entityTitle, setEntityTitle] = useState<string>();
  const [entityId, setEntityId] = useState<number>();

  const [ventureTitle, setVentureTitle] = useState<string>();
  const [ventureId, setVentureId] = useState<number>();

  const classes = useStyles();

  // const [venture] = useObservable<IVenture>(() => {
  //   return ventureService.getById(params.ventureId).pipe(RxOp.logError());
  // }, [params.ventureId]);

  // const [entity] = useObservable<IEntity>(() => {
  //   return entityService.fetchEntitiesGraph(params.ventureId)
  //     .pipe(
  //       RxOp.logError(),
  //       RxOp.filter(({ data }) => Boolean(data)),
  //       RxOp.map(({ data }) => data.find(i => i.id === Number(params.entityId)))
  //     );
  // }, [params.entityId, params.ventureId]);

  useEffect(() => {
    selectedVentureService.getSelectedVenture()
      .pipe(
        RxOp.logError()
      ).subscribe(selectedVenture => {
        setVentureId(selectedVenture.id);
        setVentureTitle(selectedVenture.name);

        ventureService
          .getById(selectedVenture.id)
          .pipe(RxOp.logError());
      });
  }, []);

  useEffect(() => {
    if(ventureId) {
      entityService
        .fetchEntitiesGraph(ventureId)
        .pipe(
          RxOp.logError(),
          RxOp.filter(({ data }) => Boolean(data)),
          RxOp.map(({ data }) => data.find(i => i.id === Number(params.entityId)))
        )
        .subscribe(entityId => {
          setEntityTitle(entityId.name);
          setEntityId(entityId.id);

          dashboardService.getStatus(ventureId, entityId.id).pipe(
            RxOp.logError(),
          ).subscribe(m => setVentureMetrics(m));

          dashboardService.getCriticality(ventureId, entityId.id).pipe(
            RxOp.logError(),
          ).subscribe(m => setCritacalityMetrics(m));

          dashboardService.getScore(ventureId, entityId.id).pipe(
            RxOp.logError(),
          ).subscribe(m => setScoreMetrics(m));

          dashboardService.getHistory(ventureId, entityId.id).pipe(
            RxOp.logError(),
          ).subscribe(m => setHistoryMetrics(m));
        });
    }
  }, [params.entityId, ventureId]);

  const { statusByVenture = null } = ventureMetrics || {};
  const totalDocumentsVenture = statusByVenture ? statusByVenture.find(i => i.status === statusesDashboard.ACTIVE_DOCUMENTS).value : 0;

  const findStatus = (status: statusesDashboard) => {
    return statusByVenture.find(i => status === i.status);
  };

  return (
   <>
    <Toolbar
      title="Dashboard"
      breadcrumbs={[
        { title: 'Dashboard', href: '/documentation/dashboard' },
        {
          title: ventureTitle,
          href: `/documentation/dashboard/venture/${ventureId}`,
        },
        {
          title: entityTitle,
          href: `/documentation/dashboard/venture/${
            ventureId
          }/entity/${entityId}`,
        },
      ]}
    />
    <Container>
      <Card>
        <CardHeader
          classes={{ title: classes.title }}
          title={ventureTitle}
          subheader={entityTitle}
        />
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={9} xl={10}>
              {statusByVenture && (
                <CardGraphs bgcolor="rgba(226,221,235,0.5)">
                  <Grid container>
                    {statusByVenture
                      .filter(
                        (item) => item.status !== statusesDashboard.ACTIVE_DOCUMENTS
                      )
                      .map((ds) => (
                        <Grid
                          item
                          key={`document-status-graph-${ds.status}`}
                          xs={12}
                          sm={6}
                          lg={3}
                        >
                          <DocumentStatus metrics={ds} total={totalDocumentsVenture} />
                        </Grid>
                      ))}
                  </Grid>
                </CardGraphs>
              )}
            </Grid>
            <Grid item xs={12} lg={3} xl={2}>
              <Grid container>
                {statusByVenture && findStatus(statusesDashboard.ACTIVE_DOCUMENTS) && (
                  <Grid item xs={12} sm={6} lg={12}>
                    <DocsActives
                      metrics={findStatus(statusesDashboard.ACTIVE_DOCUMENTS)}
                    />
                  </Grid>
                )}
                <Grid item xs={12} sm={6} lg={12}>
                  <DocumentCriticality metrics={critacalityMetrics || []} />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} lg={9} xl={10}>
              <HistoricStatus
                metrics={historyMetrics ? historyMetrics.statusByMonth : []}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={3} xl={2}>
              <ScoreVenture metrics={scoreMetrics || { max: 0, score: 0 }} />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Container>
   </>
  );
};
export default ViewVenture;